import React, { createContext, useContext } from "react"
import { useFiltersState, UseFiltersState } from "../states"
import {
  useQueryFilters,
  useInitialFilters,
  useViewFilters,
  useEmptyFiltersReset
} from "../hooks"

export const FiltersStateContext = createContext<UseFiltersState>(null)
export const useFilterStateContext = () => useContext(FiltersStateContext)

const FiltersStateProvider: React.FC = ({ children }) => {
  // initial filters depend on current user
  const { initialFilters, initialUserFilters } = useInitialFilters()

  // filters actions and current state
  const filtersState = useFiltersState(initialFilters)

  // transformed filters state that excludes filters that non-applicable in current view
  const viewFiltersState = useViewFilters(filtersState)

  // set filters to path as params
  useQueryFilters(filtersState.state, filtersState.setState, initialUserFilters)

  // remove empty added filters on view change
  useEmptyFiltersReset(filtersState.state, filtersState.onRemoveFilter)

  return (
    <FiltersStateContext.Provider value={viewFiltersState}>
      {children}
    </FiltersStateContext.Provider>
  )
}

export default FiltersStateProvider
